<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5">{{isCreate ? `Add ${page}` : `Edit ${page}`}}</h2>
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="#" @click="$router.go(-1)">Back</a></li>
          <li class="breadcrumb-item active" aria-current="page">{{isCreate ? `Add ${page}`  : `Edit ${page}`}}</li>
        </ol>
      </div>
      <div class="d-flex">
      </div>
    </div>
    <div class="row row-sm justify-content-center">
      <div class="col-xl-7 col-lg-8 col-md-12">
        <div class="card custom-card">
          <div class="card-body">
            <div>
              <h6 class="main-content-label mb-1">Page</h6>
            </div>
            <div v-if="showVideo === true">
              <ValidationObserver ref="currencyAddForm" id="currencyAddForm" tag="form" class="d-flex flex-column" @submit.prevent="formSubmit()">
                <b-tabs content-class="mt-3">
                  <b-tab :title="language.code" v-for="(language, i) in languages" :key="i">
                    <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                      <label :for="'name[' + language.code + ']'" class="form-label">Title:</label>
                      <input :id="'name[' + language.code + ']'" class="form-control" :name="'title_l[' + language.code + ']'" v-model="formData.title_l[language.code]" :class="checkValidation(classes, language.code)" placeholder="title" type="text">
                    </ValidationProvider>
                    <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                      <label :for="'remark_l[' + language.code + ']'" class="form-label">Remark:</label>
                      <input :id="'remark_l[' + language.code + ']'" class="form-control" :name="'remark_l[' + language.code + ']'" v-model="formData.remark_l[language.code]" :class="checkValidation(classes, language.code)" placeholder="remark" type="text">
                    </ValidationProvider>
                  </b-tab>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="basis" class="form-label">Basis:</label>
                    <select id="basis" class="form-control" name="basis" v-model="formData.basis" :class="classes">
                      <option value="0">0</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="6">6</option>
                    </select>
                  </ValidationProvider>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="booking_max_term" class="form-label">Booking max term:</label>
                    <input id="booking_max_term" class="form-control" name="booking_max_term" v-model="formData.booking_max_term" placeholder="booking max term" :class="classes" type="text">
                  </ValidationProvider>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="booking_range" class="form-label">Booking range:</label>
                    <input id="booking_range" class="form-control" name="booking_range" v-model="formData.booking_range" placeholder="booking range" :class="classes" type="text">
                  </ValidationProvider>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="cancel_range" class="form-label">Cancel range:</label>
                    <input id="cancel_range" class="form-control" name="cancel_range" v-model="formData.cancel_range" placeholder="cancel range" :class="classes" type="text">
                  </ValidationProvider>
                  <ValidationProvider tag="div" v-slot="{ classes }" class="d-flex align-items-center mb-3">
                    <label for="code" class="form-label">Refundable:</label>
                    <input id="code" class="ml-5 wd-25 ht-25" name="refundable" v-model="formData.refundable" placeholder="title" :class="classes" type="checkbox">
                  </ValidationProvider>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="base_price" class="form-label">Base price:</label>
                    <input id="base_price" class="form-control" name="base_price" @input="priceSum" v-model="formData.base_price" placeholder="base price" :class="classes" type="number">
                  </ValidationProvider>
                  <ValidationProvider tag="div" class="form-group">
                    <label for="price" class="form-label">Price:</label>
                    <input id="price" class="form-control" name="price" :disabled="true" v-model="formData.price" placeholder="price" type="number">
                  </ValidationProvider>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="adults_count" class="form-label">Adults Count:</label>
                    <input id="adults_count" class="form-control" name="adults_count" v-model="formData.adults_count" placeholder="adults count" :class="classes" type="number">
                  </ValidationProvider>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="children_count" class="form-label">Children Count:</label>
                    <input id="children_count" class="form-control" name="children_count" v-model="formData.children_count " placeholder="children count" :class="classes" type="number">
                  </ValidationProvider>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="continent_id" class="form-label">Room Type:</label>
                    <multiselect v-model="formData.roomType" placeholder="Select Room Type" id="continent_id" :custom-label="customLabel" :class="classes"  :close-on-select="true" track-by="id" :options="selectData">
                      <template slot="singleLabel" slot-scope="props">
                        {{props.option.title_l[$i18n.locale]}}
                      </template>
                      <template slot="option" slot-scope="props">
                        <span class="option__name">{{props.option.title_l[$i18n.locale]}}</span>
                      </template>
                    </multiselect>
                  </ValidationProvider>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="continent_id" class="form-label">Discounts:</label>
                    <multiselect v-model="formData.discount" placeholder="Select discounts" id="discounts" lable="amount" :class="classes"  :close-on-select="true" track-by="id" :options="discounts">
                      <template slot="singleLabel" slot-scope="props">
                        {{props.option.amount}}
                      </template>
                      <template slot="option" slot-scope="props">
                        <span class="option__name">{{props.option.amount}}</span>
                      </template>
                    </multiselect>
                  </ValidationProvider>
                </b-tabs>
                <button class="btn ripple btn-main-primary mt-2" :disabled="buttonDisable" :class="buttonDisable ? 'button-readonly' : ''">Submit</button>
              </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
const page = 'roomBase'
const url = 'room-base'
export default {
  name: 'roomBaseAdd',
  data () {
    return {
      page: page,
      url: url,
      showVideo: false,
      isEdit: false,
      buttonDisable: false,
      selectData: [],
      discounts: [],
      formData: {
        title_l: {},
        remark_l: {}
      },
      isCreate: false,
      cookieId: ''
    }
  },
  computed: {
    ...mapState({
      languages: state => state.language.languages,
      itemData: state => state[page].itemData
    })
  },
  created () {
    this.cookieId = this.$route.params.id
    if (this.cookieId === 'add') {
      this.isEdit = false
      this.isCreate = true
      this.showVideo = true
    } else {
      this.isEdit = true
      this.getData({ id: this.cookieId }).then(res => {
        this.showVideo = true
        this.formData = this.itemData
      })
    }
    this.getCreateData().then((res) => {
      this.selectData = res.room_types
      this.discounts = res.discounts
    })
  },
  methods: {
    ...mapActions({
      create: page + '/create',
      update: page + '/update',
      getCreateData: page + '/getCreateData',
      getData: page + '/getData'
    }),
    priceSum () {
      this.formData.price = this.formData.base_price - ((this.formData.base_price * this.formData.discount.amount) / 100)
    },
    customLabel (data) {
      return `${data.title_l[this.$i18n.locale]}`
    },
    checkValidation (data) {
      return data
    },
    formSubmit () {
      this.$refs.currencyAddForm.validate().then(success => {
        if (success) {
          this.buttonDisable = true
          this.formData.room_type_id = this.formData.roomType.id
          this.formData.discount_id = this.formData.discount.id
          delete this.formData.discount
          delete this.formData.roomType
          if (this.isCreate === true) {
            this.create(this.formData).then(() => {
              this.$toasted.success(this.$t('messages.success.courseCreated')).goAway(1500)
              this.$router.push('/' + url)
            }).catch(err => {
              if (err && err.response) {
                if (err.response.status === 422) {
                  const data = err.response.data
                  const keys = Object.keys(data)
                  const msg = data[keys[0]]
                  this.$toasted.error(msg).goAway(1500)
                } else {
                  this.$toasted.error(err.response.message).goAway(1500)
                }
              }
            }).finally(() => {
              this.buttonDisable = false
            })
          } else {
            this.update({ data: this.formData, id: this.$route.params.id }).then(res => {
              this.$toasted.success(this.$t('messages.success.courseUpdated')).goAway(1500)
              this.$router.push('/' + url)
            }).catch(err => {
              if (err && err.response) {
                if (err.response.status === 422) {
                  const data = err.response.data
                  const keys = Object.keys(data)
                  const msg = data[keys[0]]
                  this.$toasted.error(msg).goAway(1500)
                } else {
                  this.$toasted.error(err.response.message).goAway(1500)
                }
              }
            }).finally(() => {
              this.buttonDisable = false
            })
          }
        } else {
          this.$toasted.error(this.$t('messages.error.validationError')).goAway(1500)
        }
      })
    }
  },
  watch: {
    'formData.discount' () {
      this.priceSum()
    }
  }
}
</script>
